import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_COMMUNITY_POST } from "../../../api/community";
import { maskName } from "../../../utils/mask-name";
import { useUser } from "../../../core/user-context";

type CommunityPost = {
  id: string;
  content: string;
  authorName: string;
  authorId?: number | null;
  status: string;
  createdAt: string;
  replyCount: number;
  replies: Array<{
    id: string;
    content: string;
    authorName: string;
    authorId?: number | null;
    isAdmin: boolean;
    createdAt: string;
  }>;
};

const CommunityDetail: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { user } = useUser();

  const { data, loading } = useQuery(GET_COMMUNITY_POST, {
    variables: { id: id! },
    skip: !id,
  });

  const post: CommunityPost | undefined = data?.communityPost;
  const isMyPost = user?.id && post?.authorId === user.id;

  if (loading) {
    return (
      <div className="px-4 py-5">
        <button className="text-sm mb-3" onClick={() => navigate(-1)}>
          ← 뒤로
        </button>
        <div className="text-sm text-gray-500">로딩 중...</div>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="px-4 py-5">
        <button className="text-sm mb-3" onClick={() => navigate(-1)}>
          ← 뒤로
        </button>
        <div className="text-sm text-gray-500">게시글을 찾을 수 없습니다.</div>
      </div>
    );
  }

  return (
    <div className="px-4 py-5">
      <button className="text-sm mb-3" onClick={() => navigate(-1)}>
        ← 뒤로
      </button>
      <div className="text-xs text-gray-500 flex items-center gap-1">
        {isMyPost && <span className="text-[#1562fc] font-medium">내 글</span>}
        {maskName(post.authorName)} ·{" "}
        {new Date(post.createdAt).toLocaleString()}
      </div>
      <p className="text-sm mt-3 whitespace-pre-wrap">{post.content}</p>

      <div className="mt-6">
        <h2 className="text-sm font-medium">답변 {post.replies.length}</h2>
        <ul className="mt-2 space-y-3">
          {post.replies.map((r) => (
            <li
              key={r.id}
              className={`border rounded-md p-3 ${
                r.isAdmin
                  ? "bg-[#F4F5F7] border-[#1562fc]"
                  : "bg-white border-[#F4F5F7]"
              }`}
            >
              <div className="text-xs text-gray-500">
                {r.isAdmin ? (
                  <span className="text-[#1562fc] font-medium">운영자</span>
                ) : (
                  maskName(r.authorName)
                )}{" "}
                · {new Date(r.createdAt).toLocaleString()}
              </div>
              <div className="text-sm mt-1 whitespace-pre-wrap">
                {r.content}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CommunityDetail;
